import { render, staticRenderFns } from "./DataTableTh.vue?vue&type=template&id=0c9fc8bc&"
import script from "./DataTableTh.vue?vue&type=script&lang=js&"
export * from "./DataTableTh.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports